import { IconPaths } from '_metronic/helpers'
import { Button, useModal } from 'app/components'
import { DownloadAgendaModal } from '../modal/DownloadAgendaModal'
import { useT } from '_metronic/i18n/Metronici18n'

export const PegaPlantaoToolbar = () => {
  const { showModal } = useModal()
  const { t } = useT()

  const openModal = () => {
    showModal({ title: t('modal.download_agenda'), content: <DownloadAgendaModal /> })
  }

  return (
    <Button className='btn-primary' onClick={openModal} icon={IconPaths.Download}>
      {t('modal.download_agenda')}
    </Button>
  )
}
